import { ReactNode } from 'react'

import { AvailableModules } from 'generated/featureDefinitions'
import { GetModuleAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

export const LMSModuleAvailabilityWall: React.FC<{
  children: ReactNode
  showWhenEnabled?: boolean
}> = ({ children, showWhenEnabled = true }) => {
  const { company } = useCurrentSession()

  const { data: moduleData } = useQuery(GetModuleAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      ids: [AvailableModules.lms],
      companyId: company.id,
    },
  })

  const moduleAvailabilities = moduleData?.companies.moduleAvailabilities ?? []
  const hasLMSModule = isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.lms)

  const shouldRender = showWhenEnabled === hasLMSModule

  if (shouldRender) {
    return <>{children}</>
  } else {
    return <></>
  }
}
